var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_4253",
    "data-name": "Grupo 4253",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2446",
    "data-name": "Caminho 2446",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2447",
    "data-name": "Caminho 2447",
    d: "M15.833,11.083H11.25v4.583h4.583ZM14.917,1V2.833H7.583V1H5.75V2.833H4.833A1.825,1.825,0,0,0,3.009,4.667L3,17.5a1.833,1.833,0,0,0,1.833,1.833H17.667A1.839,1.839,0,0,0,19.5,17.5V4.667a1.839,1.839,0,0,0-1.833-1.833H16.75V1Zm2.75,16.5H4.833V7.417H17.667Z",
    transform: "translate(-0.25 0.833)",
    fill: "#012d5c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlue);
export default __webpack_public_path__ + "static/media/Calendar_blue.4d4ef78c.svg";
export { ForwardRef as ReactComponent };